const request = 'REQUEST';
const success = 'SUCCESS';
const failure = 'FAILURE';
const open = 'OPEN';
const close = 'CLOSE';

interface CallType {
  REQUEST: string;
  SUCCESS: string;
  FAILURE: string;
}

interface ModalType {
  OPEN: string;
  CLOSE: string;
}

export function createCallTypes(domain: string, call: string): CallType {
  const baseCall = `${call.toUpperCase()}`;
  const baseDomain = `${domain.toUpperCase()}`;

  return {
    [request]: `${baseDomain}/${baseCall}_${request}`,
    [success]: `${baseDomain}/${baseCall}_${success}`,
    [failure]: `${baseDomain}/${baseCall}_${failure}`,
  };
}

export function createModalTypes(domain: string, call: string): ModalType {
  const baseCall = `${call.toUpperCase()}`;
  const baseDomain = `${domain.toUpperCase()}`;

  return {
    [open]: `${baseDomain}/${baseCall}_${open}`,
    [close]: `${baseDomain}/${baseCall}_${close}`,
  };
}
